/**
 * Generated by scripts/generate-scoped-rbac-fallbacks.ts from
 * webddn-backend/src/constants/scopedRbacDefaults.ts.
 * Do not edit by hand — rerun generate-env / generate-env-dev / this script.
 *
 * Offline bootstrap only. Session GET …/scoped-rbac/effective is source of truth.
 * Named permission fallbacks are app_type=* only (typed overrides after effective).
 * Binding fallbacks include * + APP_TYPE=sport.
 * Binding fallbacks include * + APP_TYPE=web.
 * Resource grants are never included.
 */

export const NAMED_PERMISSION_FALLBACKS: Record<string, string> = {
  "admin.activities": "sa",
  "admin.app_types": "sa",
  "admin.appointments": "samb",
  "admin.approvals": "sam",
  "admin.approvals_config": "sa",
  "admin.authentication_setting": "s",
  "admin.hcai_config": "sa",
  "admin.header_setting": "s",
  "admin.inquiries": "sam",
  "admin.model_editor": "s",
  "admin.notifications": "sa",
  "admin.pending_payments": "sa",
  "admin.pricing_templates": "s",
  "admin.scoped_rbac": "sa",
  "admin.signup_setting": "s",
  "admin.sms_gateway": "sam",
  "admin.system_purge": "sa",
  "admin.treatment_templates": "sam",
  "admin.user_schedule": "samb",
  "admin.users": "s",
  "feature.admin_tools": "s",
  "feature.apikeys": "sa",
  "feature.apikeys.edit": "samtbu",
  "feature.apikeys.list": "sambtp",
  "feature.apikeys.super": "s",
  "feature.billing": "sambu",
  "feature.billing.manage": "sa",
  "feature.billing.payment": "sambtu",
  "feature.billing.super": "s",
  "feature.billing.transporter": "st",
  "feature.blackboard": "sambu",
  "feature.blackboard.manage": "sa",
  "feature.business_user": "sa",
  "feature.cloudflare": "s",
  "feature.companion.watch": "sambutpeu",
  "feature.company": "sambt",
  "feature.company.edit": "samtbu",
  "feature.company.manage": "sa",
  "feature.company.super": "s",
  "feature.content": "sacrw",
  "feature.content.editor": "sa",
  "feature.content.manage": "sa",
  "feature.design_system": "s",
  "feature.distance_matrix": "sa",
  "feature.finance_life": "",
  "feature.flat_rate": "sa",
  "feature.font": "sa",
  "feature.fwdu": "sambtu",
  "feature.fwdu.manage": "sa",
  "feature.health_fitness": "",
  "feature.invoice": "s",
  "feature.invoice.list": "sam",
  "feature.invoice.manage": "sa",
  "feature.invoice.staff": "samb",
  "feature.journey": "sambut",
  "feature.journey.admin": "sam",
  "feature.journey.manage": "sa",
  "feature.journey.operate": "samb",
  "feature.journey.super": "s",
  "feature.journey.use": "sambu",
  "feature.kanban": "sa",
  "feature.my_schedule": "bt",
  "feature.notifications": "sambutpeu",
  "feature.passenger": "sambtp",
  "feature.passenger.edit": "samtbu",
  "feature.passenger.manage": "sa",
  "feature.passenger.operate": "samb",
  "feature.passenger.super": "s",
  "feature.passenger.use": "sambu",
  "feature.patient_assessment": "b",
  "feature.patient_intake": "bmu",
  "feature.patient_intake.patient": "u",
  "feature.payment": "sa",
  "feature.product": "sa",
  "feature.registration": "sa",
  "feature.registration.super": "s",
  "feature.roster": "sambput",
  "feature.roster.manage": "sa",
  "feature.scraper": "s",
  "feature.sign_project": "sa",
  "feature.signup": "tp",
  "feature.subscription": "sa",
  "feature.subscription.super": "s",
  "feature.team": "sambt",
  "feature.team.manage": "sa",
  "feature.team.super": "s",
  "feature.transporter": "sat",
  "feature.transporter.edit": "samtbu",
  "feature.transporter.manage": "sa",
  "feature.transporter.super": "s",
  "feature.users.list": "sa",
  "feature.webddn_project": "s",
};

export const ACTION_BINDING_FALLBACKS: Record<string, string> = {
  "apikeys.delete": "feature.apikeys",
  "apikeys.edit": "feature.apikeys.edit",
  "apikeys.history_edit": "feature.apikeys.super",
  "billing.summary": "feature.billing.super",
  "billing.transporter": "feature.billing.transporter",
  "blackboard.manage": "feature.blackboard.manage",
  "business_user.delete": "feature.business_user",
  "business_user.edit": "feature.business_user",
  "company.delete": "feature.company.manage",
  "company.edit": "feature.company.edit",
  "company.history_edit": "feature.company.super",
  "content.delete": "feature.content.manage",
  "content.editor": "feature.content.editor",
  "content.publish": "feature.content.manage",
  "header.admin.app_types": "admin.app_types",
  "header.admin.scoped_rbac": "admin.scoped_rbac",
  "invoice.create": "feature.invoice.manage",
  "invoice.create.list": "feature.invoice.list",
  "invoice.delete": "feature.invoice.manage",
  "invoice.delete.list": "feature.invoice.list",
  "invoice.edit": "feature.invoice.list",
  "invoice.export": "feature.invoice.staff",
  "invoice.filters": "feature.invoice.manage",
  "invoice.mark_paid": "feature.invoice.manage",
  "invoice.mark_paid.list": "feature.invoice.list",
  "invoice.record_payment": "feature.invoice.manage",
  "invoice.reports": "feature.invoice.list",
  "invoice.send": "feature.invoice.manage",
  "invoice.send.list": "feature.invoice.list",
  "invoice.top_customers": "feature.invoice.list",
  "journey.admin": "feature.journey.admin",
  "journey.assign_transporter": "feature.journey.manage",
  "journey.call": "feature.journey.operate",
  "journey.delete": "feature.journey.manage",
  "journey.edit": "feature.journey.use",
  "journey.history_edit": "feature.journey.super",
  "journey.sport_create": "action.journey.sport_create",
  "passenger.admin_field": "feature.passenger.super",
  "passenger.delete": "feature.passenger.manage",
  "passenger.edit": "feature.passenger.edit",
  "passenger.history_edit": "feature.passenger.super",
  "passenger.view_parent": "feature.passenger.operate",
  "registration.approve": "feature.registration.super",
  "roster.manage": "feature.roster.manage",
  "subscription.admin": "feature.subscription.super",
  "subscription.invoice_actions": "feature.subscription",
  "subscription.retry": "feature.subscription.super",
  "team.delete": "feature.team.manage",
  "team.history_edit": "feature.team.super",
  "team.send": "feature.team.manage",
  "team.sport_manage": "action.team.sport_manage",
  "team.subscription_badge": "feature.team.manage",
  "transporter.delete": "feature.transporter.manage",
  "transporter.edit": "feature.transporter.edit",
  "transporter.history_edit": "feature.transporter.super",
};

export const FEATURE_BINDING_FALLBACKS: Record<string, string> = {
  "apikeys": "feature.apikeys",
  "billing": "feature.billing",
  "blackboard": "feature.blackboard",
  "blackboard.manage": "feature.blackboard.manage",
  "company": "feature.company",
  "content": "feature.content",
  "invoice": "feature.invoice",
  "journey": "feature.journey",
  "kanban": "feature.kanban",
  "notifications": "feature.notifications",
  "passenger": "feature.passenger",
  "payment": "feature.payment",
  "product": "feature.product",
  "registration": "feature.registration",
  "roster": "feature.roster",
  "subscription": "feature.subscription",
  "team": "feature.team",
  "tournament.live": "sport.tournament",
  "transporter": "feature.transporter",
};

export const ROUTE_BINDING_FALLBACKS: Record<string, string> = {
  "/admin/activities": "admin.activities",
  "/admin/app-types": "admin.app_types",
  "/admin/appointments": "admin.appointments",
  "/admin/approval-config": "admin.approvals_config",
  "/admin/approvals": "admin.approvals",
  "/admin/authentication-setting": "admin.authentication_setting",
  "/admin/fwdu/sms-gateway": "admin.sms_gateway",
  "/admin/hcai-config": "admin.hcai_config",
  "/admin/header-setting": "admin.header_setting",
  "/admin/inquiries": "admin.inquiries",
  "/admin/model-editor": "admin.model_editor",
  "/admin/notifications": "admin.notifications",
  "/admin/pending-payments": "admin.pending_payments",
  "/admin/pricing-templates": "admin.pricing_templates",
  "/admin/scoped-rbac": "admin.scoped_rbac",
  "/admin/signup-setting": "admin.signup_setting",
  "/admin/treatment-templates": "admin.treatment_templates",
  "/admin/user-schedule": "admin.user_schedule",
  "/admin/users": "admin.users",
  "/apikeys": "feature.apikeys",
  "/billings": "feature.billing",
  "/billings/dashboard": "feature.billing.payment",
  "/blackboard": "feature.blackboard",
  "/business-user": "feature.business_user",
  "/cloudflare": "feature.cloudflare",
  "/company": "feature.company",
  "/content-list": "feature.content",
  "/design-system": "feature.design_system",
  "/distance-matrix-cache": "feature.distance_matrix",
  "/finance-life": "feature.finance_life",
  "/flat-rate": "feature.flat_rate",
  "/font-management": "feature.font",
  "/fwdu": "feature.fwdu",
  "/health-fitness": "feature.health_fitness",
  "/health-fitness/hydration": "feature.health_fitness",
  "/health-fitness/my-routine": "feature.health_fitness",
  "/health-fitness/nutrition": "feature.health_fitness",
  "/health-fitness/progress": "feature.health_fitness",
  "/health-fitness/sleep": "feature.health_fitness",
  "/health-fitness/workout-schedule": "feature.health_fitness",
  "/invoice-management": "feature.invoice",
  "/invoice-management/list": "feature.invoice.list",
  "/journey": "feature.journey",
  "/my-schedule": "feature.my_schedule",
  "/notifications": "feature.notifications",
  "/passenger": "feature.passenger",
  "/patient-assessment": "feature.patient_assessment",
  "/patient-intake": "feature.patient_intake",
  "/payment": "feature.payment",
  "/product-management": "feature.product",
  "/registration": "feature.registration",
  "/roster": "feature.roster",
  "/scraper": "feature.scraper",
  "/sign-project": "feature.sign_project",
  "/subscription": "feature.subscription",
  "/team": "feature.team",
  "/tournament": "sport.tournament",
  "/transporter": "feature.transporter",
  "/webddn-project": "feature.webddn_project",
};
